import { graphql, ScriptStrategy, useStaticQuery } from 'gatsby';
import { Script as ScriptType } from 'lib/types';
import * as React from 'react';
import type { Maybe, UnbounceSettings } from '@types/gatsby-types';
import Script from 'analytics/components/Script';

type UnbounceScriptsProps = {
    scripts: ScriptType[];
};

const query = graphql`
    query UnbounceScriptsQuery {
        settings {
            unbounce {
                enabled
            }
        }
    }
`;

type UnbounceScriptsQuery = {
    settings: Maybe<{
        unbounce: Maybe<Pick<UnbounceSettings, 'enabled'>>;
    }>;
};

export default function UnbounceScripts({
    scripts,
}: React.PropsWithChildren<UnbounceScriptsProps>): React.ReactElement {
    const { settings } = useStaticQuery<UnbounceScriptsQuery>(query);
    const mappedScripts = React.useMemo(() => {
        return scripts.map(({ script }) => {
            // Regular expression to extract the src attribute value
            const srcRegex = /<script.*?src=['"](.*?)['"].*?<\/script>/;

            const match = srcRegex.exec(script);
            if (match) {
                // Extracted src value
                return match[1];
            }
            return null;
        });
    }, [scripts]);

    if (settings?.unbounce?.enabled) {
        return (
            <>
                {mappedScripts.map((src, idx) =>
                    src ? (
                        <Script
                            key={idx}
                            src={src}
                            strategy={ScriptStrategy.idle}
                            cookieType="necessary"
                        />
                    ) : null,
                )}
            </>
        );
    }

    return <></>;
}
